import FaultOverviewPage from "./FaultOverviewPage";
import { DataGridSettingsProvider } from "@/components/DataGridSettingsProvider";
import { PresetProvider } from "@/components/PresetProvider";
import { presetSelectionKey } from "@/constants/PageType";

export function FaultOverviewPageWrapper() {
  return (
    <PresetProvider selectionKey={presetSelectionKey("faultMonitor")}>
      <DataGridSettingsProvider pageType="faultMonitor">
        <FaultOverviewPage />
      </DataGridSettingsProvider>
    </PresetProvider>
  );
}
